import { ChangeDetectionStrategy, Component, computed, input, untracked } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Maybe } from '../../../types/base/';
import type { Icon } from '../../../types/icon-list.type';
import { ButtonComponent } from '../../button/button.component';
import { IconComponent } from '../../icon/icon.component';
import { ModalComponent } from '../modal.component';

export type ConfirmAction =
  | string
  | {
      label: string;
      callback$: () => Observable<unknown>;
      icon?: () => void;
    };

@Component({
  selector: 'evc-confirm-modal',
  imports: [
    IconComponent,
    ButtonComponent,
  ],
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent extends ModalComponent {
  icon = input<Maybe<Icon>>(undefined);
  title = input<Maybe<string>>(undefined);
  content = input<Maybe<string>>(undefined);
  action = input<Maybe<ConfirmAction>>(undefined);
  cancelLabel = input<Maybe<string>>(undefined);
  isError = input(false);
  override showCloseButton = input(false);
  override showReduceButton = input(false);

  actionLabel = computed<Maybe<string>>(() => {
    const action = this.action();

    return untracked(() => {
      if (!action) return undefined;
      if (typeof action === 'string') return action;

      return action.label;
    });
  });

  confirm(): void {
    const action = this.action();
    const action$ = !action || typeof action === 'string' ? of(true) : action.callback$();
    action$.subscribe(this.subject);
  }
}
